import { database } from '../firebase';
import { snapshotToArray } from '../helpers';

export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';
export const ADD_CATEGORY = 'ADD_CATEGORY';

export const fetchDepartments = () => async dispatch => {

	database.ref("/departments").once("value", snapshot => {
		dispatch({
			type: FETCH_DEPARTMENTS,
			payload: snapshotToArray(snapshot)
		});
	});
};

export const addNewCategory = (department, category) => async dispatch => {

	database.ref("/departments/" + department + "/categories").push(category).then(function (value) {
		dispatch(fetchDepartments());
	});

};

export const addNewDepartment = (department) => async dispatch => {

	let updates = {};
	updates['/departments/' + department.slug] = department;

	database.ref().update(updates).then(function (value) {
		dispatch(fetchDepartments());
	});;

};

export const updateDepartments = (departments) => async dispatch => {
	let updates = {};

	departments.forEach(function (department, index) {
		delete department.chosen;
		delete department.selected;
		delete department.enabled;

		department.index = index;

		if (department.categories) {

			Object.values(department.categories).forEach(function (category, index) {
				category.index = index;
				delete category.chosen;
				delete category.selected;
			});
		}

		updates['/departments/' + department.slug] = department;
	});

	database.ref().update(updates).then(function (value) {
		dispatch(fetchDepartments());
	});;

};

export const deleteDepartment = (department) => async dispatch => {
	database.ref("/departments/" + department.slug).remove().then((value) => {

		dispatch(fetchDepartments());

	});
}

export const deleteCategory = (department, category) => async dispatch => {
	database.ref("/departments/" + department + "/categories/" + category).remove().then((value) => {
		dispatch(fetchDepartments());

	});
}